/**
 * URL base de la API obtenida desde las variables de entorno.
 * Debe definirse en el archivo .env como REACT_APP_API_URL
 * @default http://localhost:3003
 */
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';
